import { Component, computed, inject, input, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ActionsManager } from '../models';
import { IActionConfig, IActionExecutedEvent } from '../types';
import { MenuModule } from 'primeng/menu';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'app-table-actions',
  templateUrl: './table-actions.component.html',
  styleUrls: ['./table-actions.component.scss'],
  imports: [ButtonModule, MenuModule, TranslateModule]
})
export class TableActions<TEntity> {
  entity = input.required<TEntity>();
  supportedActions = input.required<IActionConfig<TEntity>[]>();
  actionManager = computed(() => ActionsManager.create(this.supportedActions()));
  actionExecuted = output<IActionExecutedEvent<TEntity>>();
}
